import { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import FooterLink from "./footerLink";

interface AboutWbsLink {
  title: string;
  href: string;
}

const useAboutWbsLinks = (): AboutWbsLink[] =>
  useMemo(
    () => [
      {
        title: "Unternehmen",
        href: "https://www.wbs-gruppe.de/story-spirit-sinn/",
      },
      {
        title: "Blog",
        href: "https://www.wbstraining.de/ratgeber/",
      },
      {
        title: "Feedback geben",
        href: "https://www.wbstraining.de/bewerten/",
      },
      {
        title: "Arbeitslos melden - Ratgeber",
        href: "https://www.wbstraining.de/ratgeber/hilfe-bei-arbeitslosigkeit/",
      },
      {
        title: "Qualifizierungschancengesetz",
        href: "https://www.wbstraining.de/unternehmen/foerderungen/qualifizierungschancengesetz/",
      },
      {
        title: "Kursnet Bildungsgutschein (BGS)",
        href: "https://www.wbstraining.de/foerderungen/bildungsgutschein/",
      },
    ],
    [],
  );

const FooterLinkList = ({ links }: { links: AboutWbsLink[] }) => (
  <Box sx={{ listStyle: "none" }}>
    {links.map((link: AboutWbsLink) => (
      <FooterLink
        key={link.href}
        target="_blank"
        rel="noopener"
        href={link.href}
      >
        <Typography variant="body1" component="li" sx={{ mb: 1 }}>
          {link.title}
        </Typography>
      </FooterLink>
    ))}
  </Box>
);

const AboutWbs: () => JSX.Element = () => {
  const links = useAboutWbsLinks();
  return (
    <div data-testid="aboutwbs">
      <Typography
        variant="h5"
        component="h5"
        sx={{ mb: 4, fontWeight: "bold" }}
        color="secondary"
      >
        Über WBS TRAINING
      </Typography>
      <FooterLinkList links={links} />
    </div>
  );
};

export default AboutWbs;
